import type { ReactNode } from 'react';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import * as Styled from './IconButton.styled';

interface IconButtonProps {
  className?: string;
  handler?: () => void;
  icon: ReactNode;
  isPending?: boolean;
  isRound?: boolean;
  label: string;
  width?: number;
}

export const IconButton = ({
  handler,
  icon,
  isPending = false,
  isRound = false,
  label,
  width,
  ...deferred
}: IconButtonProps) => {
  const props = {
    $isRound: isRound,
    $width: width,
    ...(isPending ? {} : { 'aria-label': label }),
    isPending,
    onPress: handler,
    ...deferred,
  };

  return (
    <Styled.IconButton {...props}>
      {({ isPending }) => (
        <>
          {isPending ? <LoadingSpinner /> : null}
          <Styled.InnerWrapper $isPending={isPending}>
            {icon}
          </Styled.InnerWrapper>
        </>
      )}
    </Styled.IconButton>
  );
};
